// Contractor team roles — mirrors backend/utils/contractorRoles.js.
// owner + admin = full company control; manager = staff + jobs; field = assigned work only.
export const STAFF_ROLES = [
  { id: 'owner', label: 'Company owner', desc: 'Full control, including billing, settings and staff' },
  { id: 'admin', label: 'Admin', desc: 'Full control except transferring ownership' },
  { id: 'manager', label: 'Manager', desc: 'Manages jobs, the schedule, staff and forms' },
  { id: 'field', label: 'Field staff', desc: 'Sees and completes their assigned jobs and forms only' },
];

export const STAFF_ROLE_LABEL = Object.fromEntries(STAFF_ROLES.map((r) => [r.id, r.label]));

/** Field roles carry site-safety requirements (emergency contact, competency cards). */
export const isFieldRole = (id) => id === 'field' || id === 'manager';

export const staffRoleLabel = (id, isAdmin = false) =>
  STAFF_ROLE_LABEL[id] || (isAdmin ? STAFF_ROLE_LABEL.admin : STAFF_ROLE_LABEL.field);

export default STAFF_ROLES;
